import { gql } from '@apollo/client'
import { AccountFirmFragment, FirmFragments } from '../fragments/firm.fragments'
import { FirmProfileInfoFragments } from '../fragments/firmProfileInfo.fragments'

export const UpdateFirmDisplayInfoMutation = gql`
    mutation updateFirmDisplayInfo(
        $updateFirmDisplayInfoInput: UpdateFirmDisplayInfoInput!
    ) {
        updateFirmDisplayInfo(input: $updateFirmDisplayInfoInput) {
            id
            name
            subscriptionInfo {
                ...subscriptionInfoFragment
            }
            displayName
            profileInfo {
                ...firmProfileInfoFragment
            }
            status
            supportContactUser {
                ...supportContactUserFragment
            }
            totalUsers
        }
    }
    ${FirmFragments.subscriptionInfoFragment}
    ${FirmProfileInfoFragments.firmProfileInfoFragment}
    ${FirmFragments.supportContactUserFragment}
`

export const UpdateFirmDisplayInfoPageMutation = gql`
    mutation updateFirmDisplayInfo(
        $updateFirmDisplayInfoInput: UpdateFirmDisplayInfoInput!
    ) {
        updateFirmDisplayInfo(input: $updateFirmDisplayInfoInput) {
            id
            firmId
            name
            displayName
            profileInfo {
                ...firmProfileInfoPageFragment
            }
        }
    }
    ${FirmProfileInfoFragments.firmProfileInfoPageFragment}
`

export const ResendUserInviteMutation = gql`
    mutation resendUsrInvite($resendUserInviteInput: UserInviteInput!) {
        resendUserInvite(input: $resendUserInviteInput)
    }
`

export const CancelUserInviteMutation = gql`
    mutation cancelUserInvite($cancelUserInviteInput: UserInviteInput!) {
        cancelUserInvite(input: $cancelUserInviteInput)
    }
`

export const CreateFirmMutation = gql`
    mutation createFirm($firmInput: FirmInput!) {
        createFirm(firm: $firmInput) {
            ...accountFirmFragment
        }
    }
    ${AccountFirmFragment}
`

export const UpdateFirmMutation = gql`
    mutation updateFirm($firmInput: FirmInput!) {
        updateFirm(firm: $firmInput) {
            ...accountFirmFragment
        }
    }
    ${AccountFirmFragment}
`
